import React from 'react';
import { urls } from '..';
import InfoButton from '../common/InfoButton';
import Jersey from '../data/jerseys/Jersey';
import LiveScores from '../common/LiveScores';
import XRouterLink from '../common/seo/xrouter/XRouterLink';
import SocialButtons from '../common/SocialButtons';
import StatsButton from '../common/StatsButton';
import EventBets from './EventBets';
import { useUserSettings } from '../common/UserSettingsProvider';
import { getMatchStreamingProps, getStreamingId } from '../data/streaming/streamingUtils';

function getUrl(e) {
    if (e.isLive) {
        return `${urls.base}/${urls.live.base}/${urls.prematch.event}/${e.id}`;
    } else {
        return `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${e.sportRef}_${e.categoryRef}_${e.tournamentRef}/${urls.prematch.event}/${e.id}`;
    }
}

export default function TournamentEventBetsUnder(props) {
    const userSettings = useUserSettings();

    const e = props.data;
    const bets = e.bets;
    const streamingMap = getMatchStreamingProps(e);
    const streaming = streamingMap && streamingMap[e.id];
    const streamingId = getStreamingId(streaming);

    return (
        <div key={e.uniqueId} className="xs_tournamentEventBetsBelow flex flex-col bg-cs1 border-b border-b-cs7">
            <div className="px-2">
                <div className="py-1">
                    <div className="xs_teamsContainer flex h-min w-full">
                        {e.team2?.length > 0 ?
                            <XRouterLink data={e} state={e} to={getUrl(e)} className="w-full grid grid-rows-2">
                                <div className="flex items-center mb-1">
                                    <Jersey data={e.jerseys?.[0]} type={'home'} sportRef={e.sportRef} />
                                    <span className="font-medium text-sm text-cs10">{e.team1}</span>
                                    {e.score?.srv === 1 &&
                                        <span className="inline-block w-[8px] h-[8px] bg-accent-5 rounded-full ml-1" />
                                    }
                                </div>
                                <div className="flex items-center">
                                    <Jersey data={e.jerseys?.[1]} type={'away'} sportRef={e.sportRef} />
                                    <span className="font-medium text-sm text-cs10">{e.team2}</span>
                                    {e.score?.srv === 2 &&
                                        <span className="inline-block w-[8px] h-[8px] bg-accent-5 rounded-full ml-1" />
                                    }
                                </div>
                            </XRouterLink>
                            :
                            <XRouterLink data={e} state={e} to={getUrl(e)} className="w-full h-full flex flex-col justify-start">
                                <div className="flex items-center">
                                    <span className="font-medium text-sm text-cs10">{e.team1}</span>
                                </div>
                            </XRouterLink>
                        }
                        {streamingId && <i className="bi-tv" />}
                        {e.score &&
                            <LiveScores data={e.score} />
                        }
                        <div className="w-fit flex shrink-0 items-center text-cs9">
                            <div className="flex flex-col items-center">
                                <StatsButton match={e} />
                                <span className="text-xxs">
                                    (+{e.plus})
                                </span>
                            </div>
                            <i className="bi-chevron-right text-xxs" />
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="font-normal text-xxs text-cs9">{e.dateShortYear} {e.time}</div>
                        <div className="ml-1 font-bold text-xxs text-cs9">|</div>
                        <div className="ml-1 font-bold text-xxs text-cs9">{e.alias}</div>
                        <div className="w-fit grid grid-flow-col items-center justify-items-center gap-4 ml-auto">
                            {userSettings.showInfoButton && e.info &&
                                <InfoButton data={e.info} />
                            }
                            {userSettings.showSocialButtons &&
                                <SocialButtons message={''} url={getUrl(e)} urlData={e} />
                            }
                        </div>
                    </div>
                </div>
                <div className="border-t border-t-cs7">
                    <EventBets bets={bets} betsById={e.betsById} betId={props.betId} />
                </div>
            </div>
        </div>
    );
}
